import React, { useContext } from 'react';
import * as S from './styled';
import { useSnackbar } from 'notistack';
import {
  defaultBlurCompanyForm,
  defaultCompanyForm,
} from '../../../../store/invoice/utils';
import Form from '../..';
import { ExportContext } from '../../../../provider/ExportProvider';

export default function FormCompanyUpdate() {
  const {
    companies,
    getInvoice,
    setInvoice,
    updateCompany,
    setModal,
    getFormMessage,
    validateForm,
  } = useContext(ExportContext)!.controllers.company;

  const { enqueueSnackbar } = useSnackbar();

  const getForm = <T extends keyof CompanyForm>(field: T) =>
    getInvoice(`forms.companies.update.${field}`);

  const setForm = <
    T extends keyof CompanyForm,
    V extends DeepType<InvoiceState, `forms.companies.update.${T}`>,
  >(
    field: T,
    value: V,
  ) => setInvoice(`forms.companies.update.${field}`, value);

  const blurField = (field: keyof CompanyForm) => () => {
    setInvoice(`blur.companies.update.${field}`, true);
  };

  const clearForm = () => {
    const company = companies.find(
      ({ id }) => getInvoice('forms.companies.update').id === id,
    )!;
    setInvoice(`forms.companies.update`, {
      id: company.id,
      name: company.name,
    });
    setInvoice(`blur.companies.update`, defaultBlurCompanyForm());
  };

  const messages = getFormMessage('companies.update');

  const [loading, setLoading] = React.useState(false);
  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    validateForm('companies.update')
      .then(() => {
        setLoading(true);
        updateCompany()
          .then(() => {
            enqueueSnackbar('Companhia atualizada com sucesso', {
              variant: 'success',
            });
            setInvoice('forms.companies.update', {
              id: 0,
              ...defaultCompanyForm(),
            });
            setModal('single.updateCompany', false);
          })
          .catch(() => {
            enqueueSnackbar('Houve uma falha ao atualizar a companhia', {
              variant: 'error',
            });
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch(() => {
        enqueueSnackbar('Verifique a validade dos campos', {
          variant: 'error',
        });
      });
  };
  return (
    <S.Form
      style={{
        maxHeight: '80vh',
      }}
      onSubmit={onSubmit}
    >
      <S.Body>
        <S.Grid>
          <Form.Input
            label="Nome"
            value={getForm('name')}
            onChange={(e) => setForm('name', e.target.value)}
            error={messages.name}
            onBlur={blurField('name')}
          />
        </S.Grid>
      </S.Body>
      <S.Actions>
        <Form.Button type="button" onClick={clearForm}>
          Limpar
        </Form.Button>
        <Form.Button loading={loading}>Atualizar</Form.Button>
      </S.Actions>
    </S.Form>
  );
}
